<template>
  <div class="noticeboard">
    <div>
      <div class="title">
        <div>公告訊息</div>
        <div>
          <button class="outline" @click="closeNoticeboard">關閉</button>
        </div>
      </div>
      <div>
        <perfect-scrollbar>
          <div
            :class="{ watched: getWatchedListId.includes(i.id), card: true }"
            v-for="i in noticeboardList"
            :key="i.id"
          >
            <div>
              <div class="topic">
                <div>
                  <div>
                    <div class="category">{{ i.category }}</div>
                    <div class="target" :class="getClassByTarget(i.target_audience)">
                      {{ i.target_audience }}
                    </div>
                  </div>
                  <div>
                    <div class="date">公告日期：{{ i.notice_date }}</div>
                    <div class="count">點擊次數：{{ i.click_count }}</div>
                  </div>
                </div>
                <div>{{ i.topic }}</div>
              </div>
              <div class="action" @click="expandCard(i.id)">
                <font-awesome-icon
                  :icon="expandNotice.includes(i.id) ?
                    'chevron-down' : 'chevron-right'"
                />
              </div>
            </div>
            <div v-show="expandNotice.includes(i.id)">
              <div v-if="i.content.includes('http')">
                <div v-for="(i, idx) in i.content.split('\n')" :key="idx">
                  <template v-if="i.includes('http')">
                    <template v-for="(j, jIdx) in i.split(' ')">
                      <a v-if="j.includes('http')" :key="jIdx" :href="j" target="_blank">
                        {{ j }}
                      </a>
                      <span v-if="!j.includes('http')" :key="jIdx">{{ ` ${j}` }}</span>
                    </template>
                  </template>
                  <template v-else>
                    {{ i }}
                  </template>
                </div>
              </div>
              <div v-else>
                <div v-for="(i, idx) in i.content.split('\n')" :key="idx">
                  {{ i }}
                </div>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Noticeboard',
  components: {},
  props: ['noticeboardList', 'noticeboardWatchList', 'getWatchedListId'],
  data() {
    return {
      expandNotice: [],
    };
  },
  methods: {
    closeNoticeboard() {
      this.$cookies.set('isShowNoticeboard', false, 60 * 60 * 4);
      this.$store.commit('common/SET_NOTICEBOARD_STATUS', false);
    },
    getClassByTarget(target) {
      let classname;
      switch (target) {
        case '國小':
          classname = 'ele';
          break;
        case '國高中':
          classname = 'juniorHigh';
          break;
        case '全體':
          classname = 'all';
          break;
        default:
      }
      return classname;
    },
    expandCard(id) {
      if (this.expandNotice.includes(id)) {
        const idx = this.expandNotice.findIndex((i) => i === id);
        this.expandNotice.splice(idx, 1);
      } else {
        this.expandNotice.push(id);
        if (!this.getWatchedListId.includes(id)) {
          this.$emit('click-noticeboard', id);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.noticeboard {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 150;

  > div {
    position: absolute;
    width: 100vw;
    height: 100vh;
    padding: 20px;
    border: 5px solid $main-purple;
    border-radius: 10px;
    background: #efefef;
    top: 0;
    left: 0;

    > div {
      &.title {
        position: relative;
        > div {
          &:first-child {
            margin-bottom: 15px;
            font-size: 28px;
            font-weight: bold;
            text-align: center;
            color: $main-purple;
          }

          &:nth-child(2) {
            position: absolute;
            top: 0;
            right: 0;
            display: flex;

            > button {
              margin-left: 10px;
              width: fit-content;
              padding: 5px 10px;
            }
          }
        }
      };

      &:nth-child(2) {
        .ps {
          height: calc(100vh - 40px - 40px);
        }
        .card {
          background: $main-yellow;
          padding: 10px;
          margin-bottom: 12px;
          border-radius: 5px;

          &.watched {
            background: #dededc;
            color: rgb(138, 135, 135);
          }

          > div {
            &:first-child {
              display: flex;
              align-items: center;

              > div {
                &.topic {
                  flex: 1;

                  > div {
                    &:first-child {
                      display: flex;
                      align-items: center;

                      @media (max-width: 768px) {
                        flex-direction: column;
                        // justify-content: flex-start;
                        align-items: flex-start;
                      }

                      > div {
                        width: fit-content;
                        display: flex;

                        &:first-child {
                          @media (max-width: 768px) {
                            margin-bottom: 5px;
                          }
                        }
                      }

                      .target {
                        &.ele {
                          background: #0248aa;
                        }
                        &.juniorHigh {
                          background: rgb(0, 151, 23);
                        }
                        &.all {
                          background: rgb(255, 106, 0);
                        }
                      }

                      .category {
                        background: $main-purple;
                      }
                      .target,
                      .category {
                        color: #fff;
                        margin-right: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 3px 5px;
                        font-weight: 500;
                      }

                      .date,
                      .count {
                        margin-right: 15px;
                        color: rgb(84, 84, 84);
                        font-size: 14px;
                      }
                    }

                    &:nth-child(2) {
                      font-size: 22px;
                      font-weight: bold;
                      margin-top: 10px;
                    }
                  }
                }

                &.action {
                  cursor: pointer;
                  width: 25px;
                  margin-left: 20px;
                  font-size: 20px;
                }
              }
            }

            &:nth-child(2) {
              margin-top: 10px;
              color: #000;
            }
          }
        }
      }
    }
  }
}
</style>
